<template>
  <div class="modal fade" role="dialog" :id="getId">
    <div class="modal-dialog modal-xs">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header-confirm" v-if="hasCloseIcon">
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="closeModal()"
          >
            <i class="ic-close"></i>
          </button>
        </div>
        <div class="modal-body modal-confirmation">
          <div class="row text-center">
            <div class="col-sm-12">
              <div class="modal-wrapper">
                <template v-if="icon === 'ic-warning'">
                  <svg
                    class="warning-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 20 20"
                  >
                    <g fill="none">
                      <path
                        d="M8.686 2.852L2.127 14.777A1.5 1.5 0 0 0 3.441 17H16.56a1.5 1.5 0 0 0 1.314-2.223L11.314 2.852a1.5 1.5 0 0 0-2.628 0zM10 6.75a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75zm.75 7a.75.75 0 1 1-1.5 0a.75.75 0 0 1 1.5 0z"
                        fill="currentColor"
                      ></path>
                    </g>
                  </svg>
                </template>
                <template v-else>
                  <div :class="getColor">
                    <i :class="getIcon"></i>
                  </div>
                </template>
                <header>{{ header }}</header>
                <p v-html="content"></p>
                <div v-if="subContent" class="note-content">
                  {{ subContent }}
                </div>
                <div class="modal-footer">
                  <button
                    v-if="hasCancel"
                    type="button"
                    class="btn btn-default"
                    data-dismiss="modal"
                    @click="cancel"
                  >
                    {{ cancelLabel }}
                  </button>
                  <button
                    v-if="hasSubmit"
                    type="submit"
                    class="btn btn-primary text-cap"
                    @click="submit"
                  >
                    {{ submitLabel }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->
        </div>
        <!-- /.modal-body -->
      </div>
      <!-- /.modal-content -->
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "id",
    "header",
    "content",
    "closeIcon",
    "cancelLabel",
    "submitLabel",
    "color",
    "icon",
    "subContent",
  ],
  computed: {
    hasCloseIcon: function () {
      return this.closeIcon && this.closeIcon === true ? true : false;
    },
    hasCancel: function () {
      return this.cancelLabel && this.cancelLabel !== "";
    },
    hasSubmit: function () {
      return this.submitLabel && this.submitLabel !== "";
    },
    getId: function () {
      return this.id && this.id !== "" ? this.id : "confirmmodal";
    },
    getColor: function () {
      return this.color && this.color !== "" ? this.color : "confirm-icon";
    },
    getIcon: function () {
      return this.icon && this.icon !== "" ? this.icon : "ic-check";
    },
  },
  methods: {
    closeModal() {
      $(`#${this.getId}`).modal("hide");
    },
    cancel() {
      this.$emit("onCancel");
    },
    submit() {
      $(`#${this.getId}`).modal("hide");
      this.$emit("submit");
    },
  },
};
</script>
<style scoped>
.note-content {
  font-size: 13px;
  color: #999;
}
.modal-header-confirm {
  display: flex;
  justify-content: flex-end;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/ConfirmModal.vue